/* Cicabelle 2.0 — wishlist hearts (localStorage) + toast + custom-card
   Add-To-Bag. Capture-phase delegation so everything works on
   load-more-appended cards too. Locale-aware: routes and shopper-facing
   strings come from window.cb2I18n (rendered by snippets/cb-i18n.liquid). */
(function () {
  var KEY = 'cb2_wishlist';
  function i18n(k, fallback) {
    return (window.cb2I18n && window.cb2I18n[k]) || fallback;
  }
  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }
  function cartUrl() {
    return i18n('cartUrl', root() + 'cart');
  }

  function load() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); return true; }
    catch (e) { return false; }
  }

  function sync() {
    var list = load();
    var hearts = document.querySelectorAll('[data-cb2-wish]');
    for (var i = 0; i < hearts.length; i++) {
      var on = list.indexOf(hearts[i].getAttribute('data-cb2-wish')) > -1;
      hearts[i].classList.toggle('is-on', on);
      hearts[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    // the old wishlist-app badge in the header becomes the live count
    var counts = document.querySelectorAll('.wishlist-h-count, .wishlist-total-count');
    for (var c = 0; c < counts.length; c++) counts[c].textContent = list.length;
  }

  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cb2-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 1900);
  }

  // Add-To-Bag / Choose-Options on the custom cb2 cards.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var go = e.target.closest('[data-cb2-goto]');
    if (go) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = go.getAttribute('data-cb2-goto');
      return;
    }
    var add = e.target.closest('[data-cb2-add]');
    if (!add) return;
    e.preventDefault();
    e.stopPropagation();
    if (add.classList.contains('busy')) return;
    add.classList.add('busy');
    if (!add.dataset.cb2Label) add.dataset.cb2Label = add.textContent;
    add.textContent = i18n('adding', 'Adding…');
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(add.getAttribute('data-cb2-add'), 10), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      window.location.href = cartUrl();
    }).catch(function () {
      add.classList.remove('busy');
      add.textContent = add.dataset.cb2Label;
      toast(i18n('addError', 'Could not add — try the product page'));
    });
  }, true);

  // Back-button from the cart restores this page from bfcache with the busy
  // state still applied — reset any stuck buttons.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var stuck = document.querySelectorAll('[data-cb2-add].busy');
    for (var i = 0; i < stuck.length; i++) {
      stuck[i].classList.remove('busy');
      if (stuck[i].dataset.cb2Label) stuck[i].textContent = stuck[i].dataset.cb2Label;
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-cb2-wish]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-cb2-wish');
    var list = load();
    var i = list.indexOf(handle);
    var removing = i > -1;
    if (removing) list.splice(i, 1);
    else list.push(handle);
    if (!save(list)) {
      toast(i18n('wishlistError', "Wishlist isn't available on this device"));
      return;
    }
    if (removing) {
      toast(i18n('wishlistRemoved', 'Removed from your wishlist'));
    } else {
      toast(i18n('wishlistSaved', 'Saved to your wishlist ♥'));
      btn.classList.add('pop');
      setTimeout(function () { btn.classList.remove('pop'); }, 400);
    }
    sync();
    if (window.__cb2WlRefresh) window.__cb2WlRefresh();
  }, true);

  // ---- wishlist sheet (Sephora-style) ----
  (function () {
    var sheet = null, itemsEl = null, emptyEl = null;
    var productCache = {};
    function wlEls() {
      sheet = document.getElementById('cb2-wl');
      itemsEl = document.getElementById('cb2-wl-items');
      emptyEl = document.getElementById('cb2-wl-empty');
      return !!(sheet && itemsEl && emptyEl);
    }
    function money(cents) { return 'AED ' + (Math.round(cents) / 100).toFixed(2).replace(/\.00$/, ''); }
    function renderRows() {
      if (!wlEls()) return;
      var list = load();
      emptyEl.hidden = list.length > 0;
      itemsEl.innerHTML = '';
      var I = window.cb2WlI18n || {};
      list.forEach(function (handle) {
        var row = document.createElement('div');
        row.className = 'wl-row';
        row.dataset.handle = handle;
        itemsEl.appendChild(row);
        var ready = productCache[handle]
          ? Promise.resolve(productCache[handle])
          : fetch('/products/' + encodeURIComponent(handle) + '.js')
              .then(function (r) { return r.ok ? r.json() : null; })
              .then(function (p) { productCache[handle] = p; return p; })
              .catch(function () { return null; });
        ready.then(function (p) {
          if (!p) { row.remove(); return; }
          var img = document.createElement('img');
          img.src = (p.featured_image || (p.images && p.images[0]) || '') + (p.featured_image ? '&width=180'.replace('&', p.featured_image.indexOf('?') > -1 ? '&' : '?') : '');
          img.alt = '';
          img.loading = 'lazy';
          var info = document.createElement('div');
          info.className = 'wl-info';
          var a = document.createElement('a');
          a.className = 'wl-title';
          a.href = p.url;
          a.textContent = p.title;
          var price = document.createElement('div');
          price.className = 'wl-price';
          price.textContent = money(p.price);
          if (p.compare_at_price && p.compare_at_price > p.price) {
            var s = document.createElement('s');
            s.textContent = money(p.compare_at_price);
            price.appendChild(s);
          }
          info.appendChild(a); info.appendChild(price);
          var actions = document.createElement('div');
          actions.className = 'wl-actions';
          if (p.variants && p.variants.length === 1 && p.available) {
            var add = document.createElement('button');
            add.type = 'button';
            add.className = 'wl-add';
            add.setAttribute('data-cb2-add', p.variants[0].id);
            add.textContent = (I.add || 'Add To Bag');
            actions.appendChild(add);
          } else {
            var view = document.createElement('a');
            view.className = 'wl-add';
            view.href = p.url;
            view.textContent = (I.view || 'View');
            actions.appendChild(view);
          }
          var rem = document.createElement('button');
          rem.type = 'button';
          rem.className = 'wl-remove';
          rem.setAttribute('data-cb2-wish', handle);
          rem.textContent = (I.remove || 'Remove');
          actions.appendChild(rem);
          row.appendChild(img); row.appendChild(info); row.appendChild(actions);
        });
      });
    }
    function openWl() {
      if (!wlEls()) return;
      renderRows();
      // signing in carries the on-device list to the account, where the
      // claim endpoint stores it permanently (hybrid wishlist)
      var signBtn = document.getElementById('cb2-wl-signin-btn');
      if (signBtn) {
        var lst = load().slice(0, 60);
        signBtn.href = 'https://account.cicabelle.com/login' + (lst.length ? '?wl=' + encodeURIComponent(lst.join(',')) : '');
      }
      document.documentElement.classList.add('cb2wl-open');
    }
    function closeWl() { document.documentElement.classList.remove('cb2wl-open'); }
    window.__cb2WlRefresh = function () {
      if (document.documentElement.classList.contains('cb2wl-open')) renderRows();
    };
    // the old wishlist-app header heart opens OUR sheet everywhere it appears
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var heart = e.target.closest('.h-wishlist-icon, .wishlist-page-widget, #cb2-wish-open');
      if (heart && !heart.hasAttribute('data-cb2-wish')) {
        e.preventDefault();
        e.stopPropagation();
        openWl();
        return;
      }
      if (e.target.closest('#cb2-wl-close') || (e.target.id === 'cb2-wl-overlay')) closeWl();
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeWl(); });
  })();

  function arm() {
    sync();
    // the theme clones/rebuilds the header after load (sticky header) — the
    // fresh badge node is born with the server-rendered "0", so re-sync late
    window.addEventListener('load', function () { sync(); setTimeout(sync, 800); });
    var t = null;
    var mo = new MutationObserver(function (muts) {
      for (var m = 0; m < muts.length; m++) {
        var added = muts[m].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeType !== 1) continue;
          var hit = (node.hasAttribute && node.hasAttribute('data-cb2-wish')) ||
            (node.classList && (node.classList.contains('wishlist-h-count') || node.classList.contains('wishlist-total-count'))) ||
            (node.querySelector && node.querySelector('[data-cb2-wish], .wishlist-h-count, .wishlist-total-count'));
          if (hit) {
            clearTimeout(t);
            t = setTimeout(sync, 150);
            return;
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('collection:reloaded', function () { setTimeout(sync, 100); });
    // EVERY door into the account portal carries the on-device wishlist —
    // the portal claims it on any signed-in page, so the transfer no longer
    // depends on the one sheet sign-in button (an already-signed-in customer
    // never even sees /login).
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="https://account.cicabelle.com"]');
      if (!a) return;
      var list = load();
      if (!list.length) return;
      try {
        var u = new URL(a.href);
        if (!u.searchParams.get('wl')) u.searchParams.set('wl', list.slice(0, 60).join(','));
        a.href = u.toString();
      } catch (err) {}
    }, true);
  }

  if (document.readyState !== 'loading') arm();
  else document.addEventListener('DOMContentLoaded', arm);
})();

/* Cart-offers discount auto-apply (sitewide belt for drawer->checkout paths;
   the cart-page rail JS does the same). Once the eligible subtotal (excluding
   free-gift lines) crosses the configured threshold, set Shopify's discount
   cookie via /discount/CODE so checkout applies it without typing. The code's
   own store-side minimum spend is the real guard. Config from cb-i18n.liquid. */
(function () {
  var cfg = window.cb2Offers;
  if (!cfg || !cfg.code || !cfg.thr) return;
  var t = null;
  var check = function () {
    var dk = 'cb2_disc_' + cfg.code, seen = false;
    try { seen = !!sessionStorage.getItem(dk); } catch (e) {}
    if (seen) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gifts = 0;
        (cart.items || []).forEach(function (i) {
          if (i.properties && i.properties._cb2_gift) gifts += i.original_line_price;
        });
        // pre-discount subtotal: the threshold is a spend target, and the
        // applied code itself lowers total_price below it
        if (cart.original_total_price - gifts < cfg.thr) return;
        fetch('/discount/' + encodeURIComponent(cfg.code), { credentials: 'same-origin' })
          .then(function (r) { if (r.ok) { try { sessionStorage.setItem(dk, '1'); } catch (e) {} } })
          .catch(function () {});
      })
      .catch(function () {});
  };
  var kick = function () { clearTimeout(t); t = setTimeout(check, 900); };
  if (document.readyState !== 'loading') kick();
  else document.addEventListener('DOMContentLoaded', kick);
  ['cart:updated', 'cart:change', 'ajaxProduct:added'].forEach(function (ev) {
    document.addEventListener(ev, kick);
  });
  window.addEventListener('pageshow', kick);
})();
